import React from 'react';
import PropTypes from 'prop-types';
import { pie, barGraphic, lineGraphic } from 'constants/indicatorsType';
import DashboardLineChart from 'components/dashboard/charts/DashboardLineChart';
import DashboardPieChart from 'components/dashboard/charts/DashboardPieChart';
import DashboardBarChart from 'components/dashboard/charts/DashboardBarChart';
import { DashboardChartCardContainer } from './DashboardStyles';
import { emptyArray } from 'constants/emptyConst';
import { length } from 'ramda';

const DashboardIndicatorComponent = ({ dashboardIndicator }) => {
  const pieIndicators = dashboardIndicator?.indicators?.filter(indicator => indicator?.type === pie) || emptyArray;
  const graphicIndicators = dashboardIndicator?.indicators?.filter(indicator => indicator?.type === barGraphic) || emptyArray;
  const lineIndicators = dashboardIndicator?.indicators?.filter(indicator => indicator?.type === lineGraphic) || emptyArray;

  const addFinancedValue = pieIndicators.map(indicator => ({
    ...indicator,
    pie: indicator?.pie?.map(i => ({
      ...i,
      label: i?.financedValue ? `${i.label} / ${i.financedValue}` : i.label
    }))
  }));
  return (
    <>
      {addFinancedValue?.map((indicator, index) =>
        (indicator?.pie |> length) > 0 ? (
          <DashboardChartCardContainer item lg={6} xs={12} key={index}>
            <DashboardPieChart indicator={indicator} />
          </DashboardChartCardContainer>
        ) : null
      )}

      {graphicIndicators?.map((indicator, index) =>
        (indicator?.graphic |> length) > 0 ? (
          <DashboardChartCardContainer item lg={6} xs={12} key={index}>
            <DashboardBarChart indicator={indicator} />
          </DashboardChartCardContainer>
        ) : null
      )}

      {lineIndicators?.map((indicator, index) =>
        (indicator?.graphic |> length) > 0 ? (
          <DashboardChartCardContainer item lg={6} xs={12} key={index}>
            <DashboardLineChart indicator={indicator} />
          </DashboardChartCardContainer>
        ) : null
      )}
    </>
  );
};

DashboardIndicatorComponent.propTypes = {
  dashboardIndicator: PropTypes.object.isRequired
};

export default DashboardIndicatorComponent;
